const DOCUMENT_NUMBER_REGEX = /^[A-Za-z0-9/\-\s]+$/;
const DOCUMENT_NUMBER_MAX_LENGTH = 16;

export const getDocumentNumberValidationWarning = (
  value: string | null | undefined,
  fieldLabel = "Invoice number",
): string => {
  const trimmed = (value ?? "").trim();

  if (!trimmed) return "";

  if (
    trimmed.length > DOCUMENT_NUMBER_MAX_LENGTH ||
    !DOCUMENT_NUMBER_REGEX.test(trimmed)
  ) {
    return `${fieldLabel} must be 16 characters or fewer and may contain only alphabets, numerals, spaces, hyphens (-), and slashes (/).`;
  }

  return "";
};
